
import './common.scss';

import 'jquery';


// WEBPACK FOOTER //
// ./wwwroot/client/common/common.ts